import { useIntl } from 'react-intl';

import { useAccountTranslations } from './globalState/currentAccountGlobalState';

export const useTranslationOverrides = () => {
  const { formatMessage: intlFormatMessage } = useIntl();
  const i18nOverrides = useAccountTranslations();

  const formatMessage: typeof intlFormatMessage = (
    descriptor: Parameters<typeof intlFormatMessage>[0],
    values?: Parameters<typeof intlFormatMessage>[1]
  ) => {
    return intlFormatMessage(descriptor, {
      ...(i18nOverrides || {}),
      ...(values || {}),
    });
  };

  return { formatMessage };
};
